<template>
    <div class="relative">
        <div class="vx-navbar-wrapper">
            <vs-navbar class="vx-navbar navbar-custom" :color="navbarColor" :class="classObj">
                <div class="left">
                    <vs-breadcrumb :items="BreadCrumps"></vs-breadcrumb>
                </div>
                <!-- SM - OPEN SIDEBAR BUTTON -->
                <feather-icon class="sm:inline-flex xl:hidden cursor-pointer mr-1" icon="MenuIcon" @click.stop="showSidebar"></feather-icon>
                <vs-spacer></vs-spacer>
                <!-- SEARCHBAR -->
                <div class="search-full-container w-full h-full absolute pin-l rounded-lg" :class="{'flex': showFullSearch}" v-show="showFullSearch">
                    <vx-auto-suggest :data="navbarSearchAndPinList" ref="navbarSearch" placeholder="Search..." class="w-full" inputClassses="w-full vs-input-no-border vs-input-no-shdow-focus no-icon-border" icon="SearchIcon" background-overlay></vx-auto-suggest>
                    <div class="absolute pin-r h-full z-50">
                        <feather-icon icon="XIcon" class="px-4 cursor-pointer h-full close-search-icon" @click="showFullSearch = false"></feather-icon>
                    </div>
                </div>
                <feather-icon icon="SearchIcon" @click="showFullSearch = true" class="cursor-pointer navbar-fuzzy-search ml-4"></feather-icon>


                <!-- USER META -->
                <div class="the-navbar__user-meta flex items-center sm:ml-5 ml-2">
                    <div class="text-right leading-tight hidden sm:block">
                        <p class="font-semibold">{{(activeUserInfo.name ? activeUserInfo.name.toUpperCase() : '')}}</p>
                        <small>{{(activeUserInfo.name ? activeUserInfo.data.user.role : '')}}</small>
                    </div>
                    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
                        <div class="con-img ml-3"><img :src="require(`@/assets/images/portrait/small/${activeUserInfo.img}`)" alt="" width="40" height="40" class="rounded-full shadow-md cursor-pointer block"></div>
                        <vs-dropdown-menu>
                            <ul style="min-width: 9rem">
                                <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="$router.push({name:'profile'})">
                                    <feather-icon icon="UserIcon" svgClasses="w-4 h-4"></feather-icon>
                                    <span class="ml-2">Profile</span></li>
                                <vs-divider class="m-1"></vs-divider>
                                <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="$parent.logOut()">
                                    <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4"></feather-icon>
                                    <span class="ml-2">Logout</span></li>
                            </ul>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                </div>

            </vs-navbar>
        </div>
    </div>
</template>

<script>
    import VxAutoSuggest from '@/components/vx-auto-suggest/VxAutoSuggest.vue';
    import VuePerfectScrollbar from 'vue-perfect-scrollbar'
    import draggable from 'vuedraggable'

    export default {
        name: "the-navbar",
        props: {
            navbarColor: {
                type: String,
                default: "#fff",
            },
        },
        data() {
            return {
                navbarSearchAndPinList: this.$store.state.navbarSearchAndPinList,
                searchQuery: '',
                showFullSearch: false,
                settings: { // perfectscrollbar settings
                    maxScrollbarLength: 60,
                    wheelSpeed: .60,
                },
                autoFocusSearch: false,
                showBookmarkPagesDropdown: false,
            }
        },
        watch: {
            '$route'() {
                if (this.showBookmarkPagesDropdown) this.showBookmarkPagesDropdown = false
            }
        },
        computed: {
            BreadCrumps() {
                return this.$store.state.breadcrumbItems;
            },
            // HELPER
            sidebarWidth() {
                return this.$store.state.sidebarWidth;
            },
            breakpoint() {
                return this.$store.state.breakpoint;
            },

            // NAVBAR STYLE
            classObj() {
                if (this.sidebarWidth == "default") return "navbar-default"
                else if (this.sidebarWidth == "reduced") return "navbar-reduced"
                else if (this.sidebarWidth) return "navbar-full"
            },

            // BOOKMARK & SEARCH
            data() {
                return this.$store.state.navbarSearchAndPinList;
            },
            starredPages() {
                return this.$store.state.starredPages;
            },
            starredPagesLimited: {
                get() {
                    return this.starredPages.slice(0, 10);
                },
                set(list) {
                    this.$store.dispatch('arrangeStarredPagesLimited', list);
                }
            },
            starredPagesMore: {
                get() {
                    return this.starredPages.slice(10);
                },
                set(list) {
                    this.$store.dispatch('arrangeStarredPagesMore', list);
                }
            },

            // CART DROPDOWN
            cartItems() {
                return this.$store.state.eCommerce.cartItems.slice().reverse();
            },

            // PROFILE
            activeUserInfo() {
                return this.$store.state.AppActiveUser;
            },
        },
        methods: {
            showSidebar() {
                this.$store.commit('TOGGLE_IS_SIDEBAR_ACTIVE', true);
            },
            selected(item) {
                this.$router.push(item.url)
                this.showFullSearch = false;
            },
            actionClicked(item) {
                // e.stopPropogation();
                this.$store.dispatch('updateStarredPage', {index: item.index, val: !item.highlightAction});
            },
            showNavbarSearch() {
                this.showFullSearch = true;
            },
            showSearchbar() {
                this.showFullSearch = true;
            },
            elapsedTime(startTime) {
                let x = new Date(startTime);
                let now = new Date();
                var timeDiff = now - x;
                timeDiff /= 1000;

                var seconds = Math.round(timeDiff);
                timeDiff = Math.floor(timeDiff / 60);

                var minutes = Math.round(timeDiff % 60);
                timeDiff = Math.floor(timeDiff / 60);

                var hours = Math.round(timeDiff % 24);
                timeDiff = Math.floor(timeDiff / 24);

                var days = Math.round(timeDiff % 365);
                timeDiff = Math.floor(timeDiff / 365);

                var years = timeDiff;

                if (years > 0) {
                    return years + (years > 1 ? ' Years ' : ' Year ') + 'ago';
                } else if (days > 0) {
                    return days + (days > 1 ? ' Days ' : ' Day ') + 'ago';
                } else if (hours > 0) {
                    return hours + (hours > 1 ? ' Hrs ' : ' Hour ') + 'ago';
                } else if (minutes > 0) {
                    return minutes + (minutes > 1 ? ' Mins ' : ' Min ') + 'ago';
                } else if (seconds > 0) {
                    return seconds + (seconds > 1 ? `${seconds} sec ago` : 'just now');
                }

                return 'Just Now'
            },
            outside: function () {
                this.showBookmarkPagesDropdown = false
            },
        },
        directives: {
            'click-outside': {
                bind: function (el, binding) {
                    const bubble = binding.modifiers.bubble
                    const handler = (e) => {
                        if (bubble || (!el.contains(e.target) && el !== e.target)) {
                            binding.value(e)
                        }
                    }
                    el.__vueClickOutside__ = handler
                    document.addEventListener('click', handler)
                },

                unbind: function (el) {
                    document.removeEventListener('click', el.__vueClickOutside__)
                    el.__vueClickOutside__ = null

                }
            }
        },
        components: {
            VxAutoSuggest,
            VuePerfectScrollbar,
            draggable
        },
    }
</script>
